export const timezoneAbbreviations = {
    CDT: 'America/Chicago',
    CST: 'America/Chicago',
    EDT: 'America/New_York',
    EST: 'America/New_York',
    PDT: 'America/Los_Angeles',
    PST: 'America/Los_Angeles',
    MST: 'America/Boise',
    MDT: 'America/Boise',
    IST: 'Asia/Kolkata'
};